import { useFeatureStore } from '@/stores/featureStore';

export const hasFeature = (featureName: string): boolean => {
  const features = useFeatureStore.getState().features;
  return features.includes(featureName);
};
